import AdminLayout from '@/layouts/admin/index.vue';

import DashboardComponent from '@/modules/dashboard/pages/index.vue';
import AssociatesComponent from '@/modules/associates/pages/index.vue';
import ExternalsComponent from '@/modules/externals/pages/index.vue';
import AssociatedTurnsComponent from '@/modules/associated-turns/pages/index.vue';
import ExternalTurnsComponent from '@/modules/external-turns/pages/index.vue';
import CirclesComponent from '@/modules/circles/pages/index.vue';
import StatisticsComponent from '@/modules/statistics/pages/index.vue';
import AdministratorsComponent from '@/modules/administrators/pages/index.vue';
import InteractionsComponent from '@/modules/interactions/pages/index.vue';
import ConfigurationsComponent from '@/modules/configurations/pages/index.vue';
import MeetingsComponent from '@/modules/meetings/pages/index.vue';
import MeetingDetailComponent from '@/modules/meetings/pages/detail.vue';
import CategoriesComponent from '@/modules/catalogs/pages/categories.vue';
import SubspecialtiesComponent from '@/modules/catalogs/pages/subspecialties.vue';
import ProspectsComponent from '@/modules/prospects/pages/index.vue';
import CircleSimulatorComponent from '@/modules/circle-simulator/pages/index.vue';

export default [
  {
    path: '/admin',
    component: AdminLayout,
    name: 'admin',
    meta: { requiresAuth: true },
    children: [
      {
        path: '/',
        component: DashboardComponent,
        name: 'admin',
      },
      {
        path: '/dashboard',
        component: DashboardComponent,
        name: 'dashboard',
      },
      {
        path: '/meetings',
        component: MeetingsComponent,
        name: 'meetings',
      },
      {
        path: '/meetings/:id',
        component: MeetingDetailComponent,
        name: 'meeting-detail',
      },
      {
        path: '/associates',
        component: AssociatesComponent,
        name: 'associates',
      },
      {
        path: '/externals',
        component: ExternalsComponent,
        name: 'externals',
      },
      { path: '/prospects', component: ProspectsComponent, name: 'prospects' },
      { path: '/circle-simulator', component: CircleSimulatorComponent, name: 'circle-simulator' },
      {
        path: '/associated-turns',
        component: AssociatedTurnsComponent,
        name: 'associated-turns',
      },
      {
        path: '/external-turns',
        component: ExternalTurnsComponent,
        name: 'external-turns',
      },
      {
        path: '/circles',
        component: CirclesComponent,
        name: 'circles',
      },
      {
        path: '/statistics',
        component: StatisticsComponent,
        name: 'statistics',
      },
      {
        path: '/administrators',
        component: AdministratorsComponent,
        name: 'administrators',
      },
      {
        path: '/interactions',
        component: InteractionsComponent,
        name: 'interactions',
      },
      {
        path: '/configurations',
        component: ConfigurationsComponent,
        name: 'configurations',
      },
      { path: '/categories', component: CategoriesComponent, name: 'categories' },
      { path: '/subspecialties', component: SubspecialtiesComponent, name: 'subspecialties' },
    ]
  },
];
